export const useDocumentTags = () => {
  const setTitle = (title: string) => {
    if (typeof title === 'string' && document) {
        return document.title = title;
    } else return "Kroniki Akaszy • Marek Żukowski";
  };

  return { setTitle };
};
